// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"Menu__menuContainer--BDA0Z","menuItem":"Menu__menuItem--3MwfO","selected":"Menu__selected--10Mb9","promo":"Menu__promo--2klLW","title":"Menu__title--Hrtt1"};